import React from "react";
import "./workdetail.css";
import img_front from "../../assets/papersing/front_face.jpg"
import img_side from "../../assets/papersing/side_face.jpg"

const Papersing = () => {
    return (   
        <section className="section">
            <div className="workdetail__container container">
                <img src={img_front} alt="front img" className="workdetail__img"></img>
                <img src={img_side} alt="side img" className="workdetail__img"></img>
                <div className="youtube_wrap">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/qGM1h-DuFDo?si=kuVMIKAjO-OvHYbb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
                <div className="workdetail__title">
                    <div className="eng">
                        Paper Sing
                    </div>
                    紙は鳴く
                </div>
                <div className="workdetail__caption">
                    Akinori Maeda
                </div>
                <div className="workdetail__caption">
                    <div className="eng">
                    This work presents an experience in which the participant reads the novel “Neboke” (Kusaku Yumeno, 1922) through the act of tearing paper. Just as fragmented posts on social media construct new narratives, the torn fragments of text are severed from their original context and weave together fresh stories. By reinterpreting a work created a century ago in print media through the physical act of “cutting out,” the piece highlights the transformation of information consumption over the past hundred years.
                    </div>
                    本作品は、体験者が紙を破る行為によって、小説『寝ぼけ』（夢野久作・1922）を読むという体験を提示する。SNSにおける発信が断片的な物語を構築するように、破られたテキストの断片は文脈から切り離され、新たな物語を紡ぎ出す。100年前に紙媒体で生み出された作品を、身体的な「切り取り」の行為を通じて再解釈することで、この一世紀における情報消費の変容を浮かび上がらせる。
                </div>
                <div className="workdetailitem__title">
                    Related Links
                </div>
                <div className="workdetail__credit">
                    Make: Japan | Hamamtsu Micro Maker Fair 2022 <a href="https://makezine.jp/event/makerfaire/hmmf2022/" className="workdetail__weight" target="_blank" rel="noopener noreferrer">[Link]</a> <br></br>
                    紙は鳴く(2022) | IVRC HISTORY ARCHIVE <a href="https://ivrc.net/archive/%E7%B4%99%E3%81%AF%E9%B3%B4%E3%81%8F2022/" className="workdetail__weight" target="_blank" rel="noopener noreferrer">[Link]</a> <br></br>
                </div>
            </div>
        </section>
    )
    }
    
export default Papersing
